import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import io from 'socket.io-client';
import { browserHistory } from 'react-router';

import * as Actions from '../models/feeds/actions';
import Sidebar from '../components/Sidebar';
import Filter from '../components/Filter';
import Feeds from '../components/Feeds';
import FeedMore from '../components/FeedMore';
import { SOCKET_URL, NOTIFICATION_URL } from '../config';
import Store from '../library/M2Store';


class FeedController extends React.Component {
    constructor(props) {
        super(props);
        let items = [], filter = {};
        if(Store.get('m2filter_sources')) {
            let items = JSON.parse(Store.get('m2filter_sources'));
            if(items.length > 0) {
                filter.sources = items;
            }
        }


        this.state = {
            dark_mode: (Store.get('m2darkmode') && Store.get('m2darkmode') == 'dark') ? true : false,
            items: items,
            current_page: 1,
            filter: filter,
            more: {},
            show_more: false,
        };
        this.lock = false;
        this.scrollTopPosition = 0;
        this.socket = null;
        this.socketQue = [];
        this.canUpdateSocket = true;


        this.itemsScroll = 0;

        this.reloadItems = this.__reloadList.bind(this);
        this.updateScroll = this.__updateItemsScroll.bind(this);
        //reload full data list
        setTimeout(function() {
            window.location.reload();
        }, 6 * 60 * 60 * 1000);
    }

    __updateItemsScroll(scroll) {
        this.itemsScroll = scroll;
    }

    __setDarkMode(event) {
        event.preventDefault();
        let dark_mode = !this.state.dark_mode;
        if(dark_mode) {
            Store.set('m2darkmode', 'dark');
        } else {
            Store.remove('m2darkmode');
        }
        this.setState({dark_mode: dark_mode});
    }

    onSearch(data) {
        this.setState({items: [], filter: data, current_page: 1});
        this.props.actions.loadList(1, data);
    }

    addToBookmark(feed_id) {
        this.props.actions.addBookmark(feed_id);
        let items = this.state.items;
        let find = false;
        let more = {};
        for(var i in items) {
            if(items[i].id == feed_id) {
                items[i].bookmark = !items[i].bookmark;
                items[i].new = false;
                find = true;
                more = items[i];
                break;
            }
        }

        if(find) {
            this.setState({items: items, more: more});
        }
    }

    selectFeed(feed_id) {
        this.props.actions.addRead(feed_id);
        let items = this.state.items;
        let find = false;

        for(var i in items) {
            if(items[i].id == feed_id) {
                items[i].readed = true;
                items[i].new = false;
                find = true;
                break;
            }
        }

        if(find) {
            this.setState({items: items});
        }
    }

    incPage() {
        if(this.lock == false) {
            this.lock = true;
            let current_page = this.state.current_page + 1;
            this.props.actions.loadList(current_page, this.state.filter);
        }
    }

    __filterSocketItem(item) {

        if(item) {

            if(this.state.filter && (this.state.filter.date_end || this.state.filter.date_start)) {
                return false;
            }

            if(this.state.filter && this.state.filter.sources && this.state.filter.sources.length > 0) {
                if(this.state.filter.sources.indexOf(item.source_name) + 1 == 0) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    __reloadList() {
    }

    componentDidMount() {
        this.props.actions.loadList(this.state.current_page, this.state.filter);
        this.socket = io.connect(SOCKET_URL, {secure: true});
        let self = this;
        let socketFilter = this.__filterSocketItem.bind(this);
        this.socket.on('new_feed', function(data) {
            if(socketFilter(data)) {
                if(self.itemsScroll == 0) {
                    console.log('Current item scroll: ', self.itemsScroll);
                    data.new = true;
                    let items = [data];
                    self.state.items.map((item) => {
                        if (items.length < 100) {
                            items.push(item);
                        }
                    });
                    self.setState({items: items});
                } else {
                    data.new = true;
                    let items = self.state.items;
                    items.unshift(data);
                    items.splice(items.length - 1);
                    self.setState({items: items});
                }
            }

        });

        if(window.location.hash.indexOf('id=') + 1 > 0) {
            let id = window.location.hash.replace('#id=', '');
            if(id) this.props.actions.loadFeedInfo(id);
        }
    }

    showMoreItem(item) {
        if(window.location.hash.indexOf('id') + 1 > 0) {
           window.location.hash = '';
        }
        this.setState({more: item, show_more: true});
        if(item && item.id){
            this.selectFeed(item.id);
        }
    }

    hideMoreItem() {
        this.setState({more: '', show_more: false});
        if(window.location.hash.indexOf('id') + 1 > 0) {
            window.location.hash = '';
        }
    }



    inArray(id) {
        for(var i in this.state.items) {
            if(this.state.items[i].id == id) return true;
        }
        return false;
    }

    __repalceAll(string, search, to) {
        if(!string) return '';
        var target = string;
        return target.replace(new RegExp(search, 'g'), to);
    }

    __highlightObjectField(object, field, string) {


        if(object[field]) {
            let reg = new RegExp(string, "ig");
            let matches = object[field].match(reg);
            if(matches && matches.length > 0) {
                let unique_matches = matches.filter((v, i, a) => a.indexOf(v) === i);
                for (var i in unique_matches) {
                    object[field] = this.__repalceAll(object[field], unique_matches[i], '<span class="m2hlight">' + unique_matches[i] + '</span>');
                }
                return object[field];
            }
        }
        return object[field];
    }

    componentWillReceiveProps(p) {

        if(p && p.answer && p.answer.state) {

            if(p.answer.state == 'FINISH_LOAD_FEED' && p.answer.data.result == 'success') {
                this.setState({
                    show_more: true,
                    more: p.answer.data.data
                });
                window.location.hash = '';
            }

            if(p.answer.state == "FINISH_LOAD_FEEDS" && p.answer.data.result == 'success') {

                if(p.answer.data.info.page == 1) {
                    let items = [];

                    for(var i in p.answer.data.items) {
                        if(this.state.filter && this.state.filter.search) {
                            let object = p.answer.data.items[i];
                            object.title = this.__highlightObjectField(object, 'title', this.state.filter.search);
                            object.anons = this.__highlightObjectField(object, 'anons', this.state.filter.search);
                            object.description = this.__highlightObjectField(object, 'description', this.state.filter.search);
                            items.push(object);
                        } else {
                            items.push(p.answer.data.items[i]);
                        }
                    }



                    this.setState({items: items});
                } else {
                    let items = this.state.items;

                    for(var i in p.answer.data.items) {
                        if(!this.inArray(p.answer.data.items[i].id)) {
                            if(this.state.filter && this.state.filter.search) {
                                let object = p.answer.data.items[i];
                                object.title = this.__highlightObjectField(object, 'title', this.state.filter.search);
                                object.anons = this.__highlightObjectField(object, 'anons', this.state.filter.search);
                                object.description = this.__highlightObjectField(object, 'description', this.state.filter.search);
                                items.push(object);
                            } else {
                                items.push(p.answer.data.items[i]);
                            }

                        }
                    }


                    this.setState({
                        items: items,
                        current_page: p.answer.data.info.page,
                        updated: (p.answer.data.info.page == 1) ? true : false
                    });

                    this.lock = false;
                }
            }
        }
    }

    render() {
        let className = ['m2controller', 'm2controller__feed'], items = this.state.items, loading = false;

        if(this.state.dark_mode) {
            className.push('m2dark_mode');
        }

        if(this.props.answer) {
            switch(this.props.answer.state) {
                case 'START_LOAD_FEEDS':
                    loading = true;
                break;
                case 'FINISH_LOAD_FEEDS':
                    loading = false;
                break;
                case 'ERROR_LOAD_FEEDS':
                    loading = false;
                    // alert('Произошла непредвиденная ошибка, пожалуйста сообщите поддержке');
                break;
            }
        }

        let feedListClasses = ['m2content__feeds_list'];

        if(loading) {
            feedListClasses.push('m2loader_feed');
        }



        let svg_logo = '<use xlink:href="#icon-logo"></use>';

        let showMoreClassNames = ['m2content__feed_more'];

        if(this.state.show_more) {
            showMoreClassNames.push('visible');
        }

        return (
            <div className={className.join(' ')}>
                <div className="m2sidebar">
                    <Sidebar darkmode={this.__setDarkMode.bind(this)}/>
                </div>
                <div className="m2content">
                    <div className="m2content__header">
                        <div className="header__logo">
                            <svg width="164px" height="48px" dangerouslySetInnerHTML={{__html: svg_logo}}></svg>
                        </div>
                        <div className="header__filter">
                            <Filter onSearch={this.onSearch.bind(this)}/>
                        </div>
                    </div>
                    <div className="m2content__container m2feeds_container">
                       <div className={feedListClasses.join(' ')}>
                            <Feeds updateScroll={this.updateScroll} reloadItems={this.reloadItems} moreHandler={this.showMoreItem.bind(this)} incPage={this.incPage.bind(this)} bookmark={this.addToBookmark.bind(this)} select={this.selectFeed.bind(this)} items={items} />
                        </div>
                        <div className={showMoreClassNames.join(' ')}>
                            <FeedMore addToBookmark={this.addToBookmark.bind(this)} hideMore={this.hideMoreItem.bind(this)} {...this.state.more}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    answer: state.FeedReducer
});
const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchProps
)(FeedController);



// WEBPACK FOOTER //
// ./src/controllers/FeedController.js